import {
	JSON_FORM,
	SAVE_CURRENT_QUESTION_TREE_ID,
} from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'

export function handleSaveCurrentQuestionTreeId<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (
		state.type !== JSON_FORM ||
		action.type !== SAVE_CURRENT_QUESTION_TREE_ID
	) {
		return state
	}

	return {
		...state,
		currentQuestionTreeId: action.currentQuestionTreeId,
		currentQuestionId: action.currentQuestionId,
	}
}
